import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-610c4634"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-design" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.iconList && $props.iconList.length > 0)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass({'newline':$props.newline})
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.newline?$props.iconList:$props.iconList.slice(0,$props.linefew), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([            
          {'icon-design-3':$props.linefew==3},
          {'icon-design-4':$props.linefew===4  },
        ]),
              key: item.title,
              onClick: ($event: any) => ($setup.designClick(item))
            }, [
              _createVNode(_component_van_icon, {
                name: _ctx.webpFilters(item.imgsUrl),
                color: $props.color,
                size: "30"
              }, null, 8, ["name", "color"]),
              _createElementVNode("span", {
                style: _normalizeStyle({color:$props.colorSize}),
                innerHTML: item.title
              }, null, 12, _hoisted_3)
            ], 10, _hoisted_2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}